import React from "react";
import { Box } from "@mui/material";

/**
 * EmptyState — for zero-data states.
 *
 * Props: icon (lucide), title, description, action (ReactNode)
 */

function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        maxWidth: 320,
        mx: "auto",
        py: "48px",
        px: "24px",
      }}
    >
      {Icon && (
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "9999px",
            backgroundColor: "#f1f5f9",
            color: "#94a3b8",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon size={28} strokeWidth={1.75} />
        </Box>
      )}
      {title && (
        <Box
          sx={{
            mt: "16px",
            fontSize: 16,
            fontWeight: 600,
            color: "#0f172a",
            lineHeight: 1.4,
          }}
        >
          {title}
        </Box>
      )}
      {description && (
        <Box
          sx={{
            mt: "8px",
            fontSize: 14,
            fontWeight: 400,
            color: "#64748b",
            lineHeight: 1.5,
          }}
        >
          {description}
        </Box>
      )}
      {action && <Box sx={{ mt: "20px" }}>{action}</Box>}
    </Box>
  );
}

export default EmptyState;
